/*
  Staging gate password box (snippets/staging-gate.liquid).

  Nothing is posted and the page never contains the password. Submitting
  reloads the same URL as ?view=<password>: Shopify renders the
  product/collection.<password>.json template only when that file exists, so a
  wrong password simply lands back on this gate.

  The password is kept in sessionStorage (forgotten when the browser closes),
  so after one unlock every other gated page opens itself: on reaching a gate
  it is tried once per page, and the "tried" marker stops a loop if it has
  since changed.
*/
(function () {
  var KEY = 'deserve:staging';
  var TRIED = 'deserve:staging:tried';

  var form = document.querySelector('[data-staging-gate-form]');
  if (!form) return;
  var input = form.querySelector('input[name="staging_password"]');
  var error = form.querySelector('[data-staging-gate-error]');

  function store(method, key, value) {
    try {
      return window.sessionStorage[method](key, value);
    } catch (e) {
      return null;
    }
  }

  function open(password) {
    var url = new URL(window.location.href);
    url.searchParams.set('view', password);
    window.location.replace(url.toString());
  }

  function showError() {
    error.textContent = error.dataset.message;
    error.hidden = false;
    input.setAttribute('aria-invalid', 'true');
    input.focus();
  }

  var url = new URL(window.location.href);
  var attempted = url.searchParams.get('view');

  if (attempted) {
    // Back on the gate with a password in the URL: it didn't open the page.
    if (store('getItem', KEY) === attempted) store('removeItem', KEY);
    url.searchParams.delete('view');
    window.history.replaceState(window.history.state, '', url.toString());
    showError();
  } else {
    var saved = store('getItem', KEY);
    if (saved && store('getItem', TRIED) !== window.location.pathname) {
      store('setItem', TRIED, window.location.pathname);
      open(saved);
      return;
    }
  }

  form.addEventListener('submit', function (event) {
    event.preventDefault();
    // Template names are lower-case with hyphens, so match that.
    var password = input.value.trim().toLowerCase().replace(/\s+/g, '-');
    if (!password) {
      input.focus();
      return;
    }
    store('setItem', KEY, password);
    store('setItem', TRIED, window.location.pathname);
    open(password);
  });

  input.addEventListener('input', function () {
    error.hidden = true;
    input.removeAttribute('aria-invalid');
  });
})();
